const ENTER_KEYCODE = 13

export default {
  ENTER_KEY: ENTER_KEYCODE
}